<template>
  <!-- ホーム画面 -->
  <div id="offerHome">
    <div id="container">
      <div class="title is-3">代理申込み</div>
      <div class="grid-area">
        <div class="grid-container">
          <ul class="tile-container">
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice])">
              <div class="contents">
                <router-link :to="{name:'HSTAgentRequest', params:{agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-hospital-building mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">睡眠検査機器<br>配送ｻｰﾋﾞｽ申込み</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice])">
              <div class="contents">
                <router-link :to="{name:'HSTAgentLabelPrint', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-printer mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">送付先出力</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin, role.role_salesOffice])">
              <div class="contents">
                <router-link :to="{name:'PSGAgentRequest', params:{id:'full',agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-clipboard-pulse-outline mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">解析申込み<br /><span class="subtext">(フルPSG検査)</span></div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin, role.role_salesOffice])">
              <div class="contents">
                <router-link :to="{name:'PSGAgentRequest', params:{id:'easy',agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-clipboard-pulse-outline mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">解析申込み<br /><span class="subtext">(簡易検査)</span></div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'KenshinAgentRequest', params:{agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-office-building mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">企業検診申込み</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice,role.role_hospital,role.role_dealer])">
              <div class="contents">
                <router-link :to="{name:'HolterAgentRequest', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-heart-pulse mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">ホルター心電図<br>配送ｻｰﾋﾞｽ申込み</div>
                </router-link>
              </div>
            </li>
            <!-- TODO: 院内貸出機能オフ２ -->
            <li v-if="isActive([role.role_admin, role.role_salesOffice])">
              <div class="contents">
                <router-link :to="{name:'HolterDepositMachineRequest', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-heart-pulse mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">ホルター心電図<br>院内貸出機登録</div>
                </router-link>
              </div>
            </li>
            <li v-if="false">
            <!-- <li v-if="isActive([role.role_admin,role.role_hospital,role.role_dealer])"> -->
              <div class="contents">
                <router-link :to="{name:'HolterAnalysisAgentRequest', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-clipboard-outline mdi-48px"  style="position: relative;" ></i>
                    <i class="mdi mdi-heart-pulse mdi-20px" style="position: absolute;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">ホルター心電図<br>解析申込み</div>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "offerHome",
  methods: {
    isActive: function(roles){
      return (roles.indexOf(this.roleId) >= 0);
    }    
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    return {
      role: role,
      roleId: roleId
    };
  },
  components: {}
};
</script>

<style lang="scss" >
.service-list {
  width: 100%;
}
.grid-area {
  display: grid;
  width: 900px;
  margin: 0 auto;
}
.grid-container {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: 150px 1fr 100px;
  height: 100vh;
}

/*デザイン設定*/
.tile-container {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.tile-container > li {
  height: 150px;
  width: 150px;
  padding: 5px;
  background: linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  display: table-cell;
  text-align: center;
}
.contents {
  display: table-cell;
  height: 150px;
  width: 150px;
  text-align: center;
  vertical-align: middle;
}

/*グリッド設定*/
.tile-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}
.subtext {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/offer/offerHome.vue